<template>

  <div>
    <TopButtonsComponent
      :jobCreatorId="'not-required'"
      v-on:backToApplications="$emit('backToApplications', 'Applications')"
      v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
      v-bind:isApplicationPage="isApplicationPage"
    />

    <div class="application-review-container"  v-if="!loading && application">

      <div class="left-application-review-content">
        <UserApplications
          v-bind:jobHeading="'Applications'"
          v-bind:jobName="jobInfo && jobInfo.title"
          v-bind:jobApplications="otherApplicationsRelatedToJob"
          v-bind:jobLocation="`${jobInfo && jobInfo.city, jobInfo && jobInfo.state}`"
          v-on:viewApplication="emitApplicationId"
        />
      </div>

      <div class="right-application-review-content">
        <div class="general-style first-layer">
          <img
            :src="applicantInfo.profileImage" 
            v-if="applicantInfo && applicantInfo.profileImage"
            alt="Applicant profile image"
          />
          <img v-else src="../assets/images/placeholder.png" alt="Placeholder image" />
          <div class="applicant-name-and-contact">
            <h2 class="name" v-if="applicantInfo">
              {{ applicantInfo.firstName }} {{ applicantInfo.lastName }}
            </h2>
            <div class="contact">
              <span>
                <h3>Email</h3>
                <p v-if="applicantInfo && applicantInfo.emailAddress">
                  <a :href="`mailto:${applicantInfo.emailAddress}`" target="_blank">{{ applicantInfo.emailAddress }}</a>
                </p>
                <p v-else>—</p>
              </span>
              <span>
                <h3>Phone</h3>
                <p v-if="applicantInfo && applicantInfo.phone">
                  <a :href="`tel:${applicantInfo.phone}`">{{ applicantInfo.phone }}</a>
                </p>
                <p v-else>—</p>
              </span>
              <span>
                <h3>Location</h3>
                <p v-if="applicantInfo && applicantInfo.city || applicantInfo && applicantInfo.state">
                  {{ getUserLocation }}
                </p>
                <p v-else>—</p>
              </span>
            </div>
          </div>
        </div>
        <div v-if="applicantInfo && applicantInfo.bio" class="general-style second-layer bio">
          <h2>Bio</h2>
          <p>
            {{applicantInfo.bio}}
          </p>
          <!-- <p v-else>
            Candidate's bio not available at this time.
          </p> -->
        </div>
        <div v-if="application.cvUrl || jobInfo && jobInfo.videoCvGuide" class="general-style third-layer">
          <h2>Application Asset(s)</h2>
          <div class="links">
            <span v-if="application.cvUrl">
              <h3>Curriculum Vitae | Resume</h3>
              <p>
                <span>
                  <a class="touch" :href="application.cvUrl" target="_blank">
                    View Candidate's CV
                  </a>
                </span>
                <button class="touch" @click="downloadCV(application.cvUrl)">
                  Download CV
                </button>
              </p>
            </span>
            <span v-if="jobInfo && jobInfo.videoCvGuide">
              <h3>Video File</h3>
              <p @click="showVideoModal=true">
                <span class="touch">
                  <!-- {{frontendAppUrl}}videos/{{applicantInfo && applicantInfo.firstName}}.{{ applicantInfo && applicantInfo.lastName }} -->
                  View Candidate's Video
                </span>
              </p>
              <!-- <p v-else style="color: #7d7d7d; font-weight: normal;">
                No video file submission found or required.
              </p> -->
            </span>
          </div>
        </div>
        <div
        class="general-style fourth-layer"
        v-if="jobInfo && jobInfo.questionOne || jobInfo && jobInfo.questionTwo || jobInfo && jobInfo.questionThree"
        >
          <h2>Job Questionnaire(s)</h2>
          <div class="responses">
            <span>
              <h3 v-if="jobInfo.questionOne">{{jobInfo.questionOne}}</h3>
              <p v-if="application.firstResponse">{{application.firstResponse}}</p>
            </span>
            <span>
              <h3 v-if="jobInfo.questionTwo">{{jobInfo.questionTwo}}</h3>
              <p v-if="application.secondResponse">{{application.secondResponse}}</p>
            </span>
            <span>
              <h3 v-if="jobInfo.questionThree">{{jobInfo.questionThree}}</h3>
              <p v-if="application.thirdResponse">{{application.thirdResponse}}</p>
            </span>
          </div>
        </div>
        <div v-if="jobInfo && jobInfo.videoCvGuide" class="general-style second-layer video-guide">
          <h2>Job Video Question(s) or Guide</h2>
          <p>{{jobInfo.videoCvGuide}}</p>
        </div>
        <div
          v-if="application.shortlistComment || application.interviewComment || application.hireComment || application.declineComment"
          class="general-style fifth-layer"
        >
          <h2>Application Review Comment(s)</h2>

          <div class="review-comment">
            <div v-if="application.shortlistComment" class="comment-wrapper">
              <span>Shortlisted:</span>
              <p>{{ application.shortlistComment }}</p>
            </div>

            <div v-if="application.interviewComment" class="comment-wrapper">
              <span>Invited for Interview:</span>
              <p>{{ application.interviewComment }}</p>
            </div>

            <!-- Todo: Decide if we want to have a separate comment for interview completion or just keep it as part of the hired comment. --> 
            <!-- <div v-if="application.interviewCompletedComment" class="comment-wrapper">
              <span>Interview Completed:</span>
              <p>{{ application.interviewCompletedComment }}</p>
            </div> -->

            <div v-if="application.hireComment" class="comment-wrapper">
              <span>Hired:</span>
              <p>{{ application.hireComment }}</p>
            </div>

            <div v-if="application.declineComment" class="comment-wrapper">
              <span>Declined:</span>
              <p>{{ application.declineComment }}</p>
            </div>
          </div>

        </div>

        <div class="buttons">
          <button
            class="shortlist-button"
            v-if="application.status === 'in-review'"
            @click="showShortlistModal"
          >
            Shortlist
          </button>
          <button
            class="schedule-button"
            v-if="application.status === 'shortlisted'"
            @click="showInviteModal"
          >
            Invite for Interview
          </button>
          <button
            class="hire-button"
            v-if="application.status === 'scheduled-for-interview'"
            @click="showHireModal"
          >
            Hire
          </button>
          <button
          class="decline-button"
          v-if="application.status !== 'declined' && application.status !== 'hired'"
          @click="showDeclineModal"
          >
            Decline
          </button>
        </div>
      </div>
    </div>

    <!-- Please wait component -->
    <div class="loading-text" v-if="loading">
      <p>Please wait</p>
      <div v-bind:class="{ loading: loading }"></div>
    </div>

    <!-- Decision Modal for Applicaton Review -->
    <div v-if="showReviewModal">
      <ReviewDecisionModal
          :verb="modalVerb"
          :subject="modalSubject"
          :reviewImage="image"
          v-on:modalAction="reviewAction"
        />
    </div>

    <!-- Decision Modal for Applicaton Review -->
    <div v-if="showSuccessModal">
      <SuccessModal
        v-on:closeSuccessModal="showSuccessModal = false"
        v-bind:successImage="successImage"
        v-bind:successTitle="successTitle"
        v-bind:successMessage="successMessage"
        />
    </div>

    <!-- Decision Modal for scheduling Interview -->
    <div v-if="showScheduleModal">
      <ScheduleInterviewModal
        :verb="modalVerb"
        :subject="modalSubject"
        :reviewImage="image"
        :candidateName="applicantFullName"
        :companyName="jobInfo && jobInfo.companyName"
        :jobTitle="jobInfo && jobInfo.title"
        v-on:modalAction="reviewAction"
      />
    </div>

    <!-- Video popup modal -->
    <div v-if="showVideoModal">
      <VideoModal
        v-on:closeVideoModal="showVideoModal = false"
        :videoUrl="application.videoUrl"
        :applicantName="applicantFullName"
      />
    </div>
  </div>
</template>

<script>
import UserApplications from '../components/JobDetail/UserApplications.vue';
import TopButtonsComponent from '../components/JobDetail/TopButtonsComponent.vue';
import ReviewDecisionModal from '../components/Modals/ReviewDecisionModal.vue';
import SuccessModal from '../components/Modals/SuccessModal.vue';
import ScheduleInterviewModal from '../components/Modals/ScheduleInterviewModal.vue';
import VideoModal from '../components/Modals/VideoModal.vue';

import shortlistReviewImage from '../assets/images/review-logo.png';
import shortlistedImage from '../assets/images/shortlisted-icon.png';
import declineImage  from '../assets/images/decline-logo.png';
import declinedImage from '../assets/images/shortlisted-icon.png';
import inviteImage from '../assets/images/invite-logo.png';
import successImage from '../assets/images/success-logo.png';
import hireImage from '../assets/images/hire-logo.png';
import hiredImage from '../assets/images/hired-logo.png';

export default {
  name:'ApplicationReview',
  props: ['applicationId'],
  components: {
    UserApplications,
    TopButtonsComponent,
    ReviewDecisionModal,
    SuccessModal,
    ScheduleInterviewModal,
    VideoModal,
  },
  data() {
    return {
      isApplicationPage: true,
      application: null,
      otherApplicationsRelatedToJob: null,
      applicantInfo: null,
      jobInfo: null,
      loading: true,
      image: null,
      modalVerb: null,
      modalSubject: null,
      showReviewModal: false,
      showScheduleModal: false,
      showSuccessModal: false,
      successImage: null,
      successTitle: null,
      successMessage: null,
      showVideoModal: false,
      // frontendAppUrl: `${process.env.VUE_APP_BASE_URL}`,
    };
  },
  computed: {
    getUserLocation() {
      const location = this.applicantInfo && this.applicantInfo.city && this.applicantInfo.state
      ? `${this.applicantInfo.city}, ${this.applicantInfo.state}`
      : this.applicantInfo && this.applicantInfo.city ? this.applicantInfo.city
      : this.applicantInfo && this.applicantInfo.state ? this.applicantInfo.state
      : null;

      return location;
    },
    applicantFullName() {
      if (this.applicantInfo && this.applicantInfo.firstName && this.applicantInfo.lastName) {
        return `${this.applicantInfo.firstName} ${this.applicantInfo.lastName}`;
      } else if (this.applicantInfo && this.applicantInfo.firstName) {
        return this.applicantInfo.firstName;
      } else if (this.applicantInfo && this.applicantInfo.lastName) {
        return this.applicantInfo.lastName;
      } else {
        return 'Candidate';
      }
    }
  },
  methods: {
    downloadCV(link) {
      fetch(link).then((res) => {
        res.arrayBuffer().then((buffer) => {
          let url = window.URL.createObjectURL(new Blob([buffer]));
          let link = document.createElement('a');
          link.href = url;

          link.setAttribute('download', `${this.applicantInfo.firstName}_${this.applicantInfo.lastName}_cv.pdf`); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      });
    },
    showDeclineModal() {
      this.modalVerb = 'decline';
      this.modalSubject = 'candidate';
      this.image = declineImage;
      this.showReviewModal = true;
    },
    showInviteModal() {
      this.modalVerb = 'invite';
      this.modalSubject = 'candidate';
      this.image = inviteImage;
      this.showScheduleModal = true;
    },
    showHireModal() {
      this.modalVerb = 'hire';
      this.modalSubject = 'candidate';
      this.image = hireImage;
      this.showReviewModal = true;
    },
    showShortlistModal() {
      this.modalVerb = 'shortlist';
      this.modalSubject = 'candidate';
      this.image = shortlistReviewImage;
      this.showReviewModal = true;
    },
    reviewAction(action) {

      if(action.value === 'cancel') {
        this. modalVerb = null;
        this.modalSubject = null;
        this.image = null;
        this.toggleReviewModal();
        this.showScheduleModal = false;
      }

      else if(action.value === 'confirm') {
        this.toggleReviewModal();
        this.showScheduleModal = false;
        this.loading = true;

        switch(this.modalVerb){

          case 'shortlist':
            if(this.application.status === 'in-review') {
              this.$store
              .dispatch(
                'reviewApplication',
                {
                  id: this.application.id,
                  status: 'shortlisted',
                  reviewComment: action.reviewComment
                })
              .then((res) => {
                if(res.response){
                  this.showSuccessModal = true;
                  this.successImage = shortlistedImage;
                  this.successTitle = 'Shortlisted!';
                  this.successMessage = 'Application successfully shortlisted';
                  this.$toastr.success(res.response.message, 'Success');
                  this.getSingleApplication(this.application.id);
                }
                if(res.error){
                  this.loading = false;
                  this.$toastr.error(res.error.error, 'Failed');
                }
              });
            }
            break;

          case 'decline':
            if(this.application.status !== 'hired') {
              this.$store
              .dispatch(
                'reviewApplication',
                {
                  id: this.application.id,
                  status: 'declined',
                  reviewComment: action.reviewComment
                })
              .then((res) => {
                if(res.response){
                  this.showSuccessModal = true;
                  this.successImage = declinedImage;
                  this.successTitle = 'Declined!';
                  this.successMessage = 'Application successfully declined';
                  this.$toastr.success(res.response.message, 'Success');
                  this.getSingleApplication(this.application.id);
                }
                if(res.error){
                  this.loading = false;
                  this.$toastr.error(res.error.error, 'Failed');
                }
              });
            }
            break;

          case 'invite':
            if(this.application.status !== 'hired' && this.application.status !== 'declined') {
              this.$store
              .dispatch(
                'reviewApplication',
                {
                  id: this.application.id,
                  status: 'scheduled-for-interview',
                  reviewComment: action.reviewComment
                })
              .then((res) => {
                if(res.response){
                  this.showSuccessModal = true;
                  this.successImage = successImage;
                  this.successTitle = 'Interview Scheduled!';
                  this.successMessage = 'Candidate successfuly invited for interview';
                  this.$toastr.success(res.response.message, 'Success');
                  this.getSingleApplication(this.application.id);
                }
                if(res.error){
                  this.loading = false;
                  this.$toastr.error(res.error.error, 'Failed');
                }
              });
            }
            break;

          case 'hire':
            if(this.application.status !== 'hired' && this.application.status !== 'declined') {
              this.$store
              .dispatch(
                'reviewApplication',
                {
                  id: this.application.id,
                  status: 'hired',
                  reviewComment: action.reviewComment
                })
              .then((res) => {
                if(res.response){
                  this.showSuccessModal = true;
                  this.successImage = hiredImage;
                  this.successTitle = 'Hired!';
                  this.successMessage = 'Candidate successfully hired';
                  this.$toastr.success(res.response.message, 'Success');
                  this.getSingleApplication(this.application.id);
                }
                if(res.error){
                  this.loading = false;
                  this.$toastr.error(res.error.error, 'Failed');
                }
              });
            }
            break;
        }
      }
    },
    toggleReviewModal() {
      this.showReviewModal = false;
    },
    emitApplicationId(id){
      this.loading = true;
      this.$emit('viewApplication', id);
      // this.$router.history.current.params.applicationId = id;
      if(id === this.$router.history.current.params.applicationId) {
        this.loading = false;
        null;
      } else {
        this.$router.push(`/user/applications/${id}/review`);
        this.getSingleApplication(id);
      }
    },
    async getSingleApplication(id){
      await this.$store
        .dispatch('getApplication', id)
        .then((res) => {
          if (res.response) {
            this.application = res.response.application;
            this.applicantInfo = res.response.application.applicantInfo;
            this.jobInfo = res.response.application.jobInfo;
            this.otherApplicationsRelatedToJob = res.response.application.otherApplicants;
            this.loading = false;
          }
        });
    }
  },
  mounted() {
    this.getSingleApplication(this.$router.history.current.params.applicationId);
  },
};
</script>

<style scoped>
@keyframes buttonLoadingSpinner {
    from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
  }

  .loading-text {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 50px;
    color: white;
    justify-content: center;
  }
  .loading::after {
    content: "";
    position: absolute;
    width: 100px;
    height: 100px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-top-color: var(--white);
    border-right-color: var(--white);
    border-radius: 50%;
    animation: buttonLoadingSpinner 1s linear infinite;
  }

.application-review-container {
  display: flex;
}
.touch {
  cursor: pointer;
  font-size: 14px;
  text-transform: inherit !important;
}
.general-style {
  background: var(--white);
  box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
  border-radius: 15px;
  padding: 50px 30px;
}
.left-application-review-content {
  margin-right: 30px;
}
.applicant-card {
  width: 100%;
  border-bottom: 0.5px solid #8a8a8a;
  border-right: 0.5px solid #8a8a8a;
  padding: 15px;
}
.applicant-card h3 {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 27px;
  margin-bottom: 12px;
}
.applicant-card address {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #707070;
  margin-bottom: 16px;
}
.applicant-card .name-title {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #707070;
  margin-bottom: 12px;
}
.applicant-card .name-title .name {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #252525;
}
.shortlisted {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #ffb300;
}
.right-application-review-content {
  width: 65%;
}
.fourth-layer {
  margin-bottom: 30px;
}
.first-layer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 30px;
  width: 100%;
}
.first-layer img {
  border-radius: 6px;
  width: 280px;
  /* height: 150px; */
  max-height: 250px;
  margin-right: 20px;
  object-fit: cover;
}
/* .applicant-name-and-contact {
  margin-top: 30px;
} */
.first-layer .applicant-name-and-contact .name {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 49px;
  margin-bottom: 30px;
  color: var(--colorSecondary);
  text-transform: capitalize;
}
.first-layer .applicant-name-and-contact .contact {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.contact span {
  padding: 0 15px;
}
.contact span:first-child {
  padding-left: 0;
  max-width: 45%;
  word-wrap: break-word;
}
.third-layer .links,
.fourth-layer .responses {
  display: flex;
  /* flex-flow: wrap; */
}
.first-layer .applicant-name-and-contact .contact h3,
.third-layer .links h3,
.fourth-layer .responses h3 {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.989rem;
  margin-right: 20px;
  color: #707070;
}
.third-layer .links h3 {
  font-size: 1rem;
  line-height: 1.809rem;
}
.first-layer .applicant-name-and-contact .contact p,
.third-layer .links p,
.fourth-layer .responses p {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.809rem;
  margin-top: 12px;
  color: var(--colorSecondary);
}
.third-layer .links p {
  color: var(--colorPrimary);
}
.second-layer, .fifth-layer {
  margin-bottom: 30px;
  text-align: justify;
  overflow-wrap: break-word; /* Standard modern property */
  word-break: break-word; /* Fallback for older browsers */
}
.second-layer h2,
.third-layer h2,
.fourth-layer h2,
.fifth-layer h2 {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.989rem;
  color: #263238;
  margin-bottom: 20px;
}
.second-layer p, .fifth-layer p {
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.65rem;
  color: #7d7d7d;
}
.third-layer {
  margin-bottom: 30px;
}
.third-layer .links span {
  margin-right: 50px;
}
.links a, a {
  line-height: 1.809rem;
  color: var(--colorPrimary);
}
.links a, .links button, a {
  /* text-transform: lowercase; */
  font-size: 14px;
}
.fourth-layer .responses {
  align-items: center;
  justify-content: space-between;
}
.fourth-layer .responses h3, .fourth-layer .responses p {
  text-transform: capitalize;
  font-size: 1rem;
}
/* .bio, .video-guide, .review-comment {
  white-space: pre-wrap;
} */
.review-comment {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.comment-wrapper {
  margin-bottom: 35px;
  border-bottom: solid 1px #c9c9c9;
  padding-bottom: 30px;
  line-height: 1.989rem;
}
.comment-wrapper:last-child {
  margin-bottom: 0;
  border-bottom: none;
  padding-bottom: 0;
}
.comment-wrapper span {
  font-weight: 600;
}
.buttons {
  margin-top: 60px;
  display: flex;
  align-items: right;
  justify-content: right;
}
.buttons .shortlist-button,
.buttons .schedule-button,
.buttons .hire-button,
.buttons .decline-button {
  width: 175px;
  height: 50px;
  color: var(--white);
  text-transform: capitalize;
  font-family: 'montserrat';
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 20px;
  border-radius: 5px;
}
.buttons .shortlist-button,
.buttons .schedule-button,
.buttons .hire-button {
  background: var(--colorPrimary);
}
.buttons .schedule-button {
  width: 250px;
}
.buttons .decline-button {
  background: var(--white);
  border: 2px solid #ff1e56;
  color: #ff1e56;
  margin-left: 15px;
}

/* Responsiveness */
@media only screen and (min-width: 1565px) {
  .applicant-name-and-contact {
    /* width: 60%; */
    max-width: 80%;
  }
}
@media only screen and (max-width: 1564px) {
  .first-layer img {
    margin-bottom: 30px;
  }
  .applicant-name-and-contact {
    width: 100%;
  }
}
@media only screen and (min-width: 1300px) {
  .right-application-review-content {
    width: 75%;
  }
}
@media only screen and (min-width: 1200px) {
  .first-layer img {
    max-width: 20%;
  }
}
@media (min-width: 1081px) and (max-width: 1150px) {
  .right-application-review-content {
    width: 60%;
  }
}
@media only screen and (max-width: 1450px) {
  .third-layer .links,
  .fourth-layer .responses {
    flex-flow: wrap;
    justify-content: space-between;
  }
  .links span, .responses span {
    margin-bottom: 30px;
  }
  .links span:last-child {
    margin-bottom: 0;
  }
}
@media only screen and (max-width: 1080px) {
  .application-review-container {
    flex-direction: column-reverse;
  }
  .right-application-review-content {
    width: 100%;
    margin-bottom: 60px;
  }
  .left-application-review-content {
    margin-right: 0;
  }
}
@media only screen and (max-width: 670px) {
  .first-layer .applicant-name-and-contact .contact {
    display: block;
  }
  .contact span[data-v-056c3a58]:first-child {
    padding-left: 0;
    max-width: unset;
  }
  button.touch {
    text-align: left;
  }
}
@media only screen and (max-width: 440px) {
  .job-detail-heading {
    display: block;
  }
}
@media only screen and (max-width: 403px) {
  .second-layer h2, .fifth-layer h2 {
    text-align: left;
  }
}

</style>
